/* @flow */

import { createSelector } from 'reselect';
import { type UsuarioState } from './usuario-types';
import { type State } from '../preact-app/types';
import getCorFundo from '../usuario/get-cor-fundo';
import { type StateColors } from '../utils/types';

export type AutenticarAction = {
    type: 'usuario/AUTENTICAR',
    usuario: UsuarioState,
};

type Action =
    | AutenticarAction;

// Action Types

export const AUTENTICAR = 'usuario/AUTENTICAR';

// Action Creator

export const autenticar = (usuario: UsuarioState) => ({ type: AUTENTICAR, usuario });

// Selectors

export const getUsuario = (state: State) => state.usuario;

export const getNome = (state: State) => {
    const usuario = getUsuario(state);
    return usuario ? usuario.nome : null;
};

export const getEmail = (state: State) => {
    const usuario = getUsuario(state);
    return usuario ? usuario.email : null;
};

export const getInicial: State => string = createSelector(
    getNome,
    nome => nome.charAt(0),
);

export const getCor: State => StateColors = createSelector(
    getInicial,
    inicial => getCorFundo(inicial),
);

const initialState = null;

const usuarioReducer = (state: UsuarioState = initialState, action: Action): UsuarioState => {
    switch (action.type) {
    case AUTENTICAR:
        return action.usuario;
    default:
        return state;
    }
};

export default usuarioReducer;
